import { render, staticRenderFns } from "./ProcessModule.vue?vue&type=template&id=2e8cd82a&scoped=true&"
import script from "./ProcessModule.vue?vue&type=script&lang=js&"
export * from "./ProcessModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8cd82a",
  null
  
)

export default component.exports